import { ReduxStore } from 'store/types';

function getDocumentsIsLoading(state: ReduxStore): boolean {
  return state.intervention.getDocuments.config.isLoading;
}

export default getDocumentsIsLoading;
